import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, inject, model } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { IKeyVal } from '../../../@core/interfaces/IKeyVal';
import { SystemService } from '../../../@core/services/system.service';
import { GenericEnumDropDownComponent } from '../../controls/generic-enum-drop-down/generic-enum-drop-down.component';

@Component({
    selector: 'app-all-entity-names-drop-down',
    templateUrl: './all-entity-names-drop-down.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        FormsModule,
        FormlyModule,
        ReactiveFormsModule,
        GenericEnumDropDownComponent
    ]
})
export class AllEntityNamesDropDownComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {
  systemService = inject(SystemService);
  itemsSig = model<IKeyVal[]>([]);

  constructor() {
    super();
  }

  async ngAfterViewInit() {
    const allEntities = (await this.systemService.getAllEntityNames()).getAllEntityNames;
    let converted = await this.systemService.entityNamesToColumnDataSource(allEntities);
    this.itemsSig.set(converted);
  }
}
